/* eslint max-len:0 */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * InstagramIcon Return the instagram icon as a functional Component
 *
 * @param {String} altText for svg alt
 * @returns {Function} icon svg
 * @public
 */
function InstagramIcon({ altText }) {
  // eslint-disable-next-line max-len
  return (
    <React.Fragment>
      <span className='sr-only'>{ altText }</span>
      <svg role='img' aria-labelledby={ altText } xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
        <title id={ altText }>{ altText }</title>
        <path d='M22 15.15a9.89 9.89 0 0 1-.41 3.15 5.12 5.12 0 0 1-4 3.47A16.68 16.68 0 0 1 14 22H8.83a9.85 9.85 0 0 1-3.15-.41 5.13 5.13 0 0 1-3.48-4 13.8 13.8 0 0 1-.2-2.76v-6a9.58 9.58 0 0 1 .43-3.13 5.09 5.09 0 0 1 4-3.47A18.12 18.12 0 0 1 10 2h6.09a6.53 6.53 0 0 1 3.56 1.1 5.26 5.26 0 0 1 2.17 3.58A21.15 21.15 0 0 1 22 10v5.15zm-2-8.23A3.42 3.42 0 0 0 17.28 4a13.37 13.37 0 0 0-2.75-.21H9.47A14.51 14.51 0 0 0 6.92 4 3.36 3.36 0 0 0 4.1 6.43 9 9 0 0 0 3.83 9v4.08a30.6 30.6 0 0 0 .14 3.71A3.43 3.43 0 0 0 6.71 20a12.83 12.83 0 0 0 2.77.2h5a14.56 14.56 0 0 0 2.59-.2 3.4 3.4 0 0 0 2.59-1.83 5.23 5.23 0 0 0 .47-2.1c.08-1.36.07-2.73.06-4.09V9.46A18.25 18.25 0 0 0 20 6.92zm-8 10.21a5.14 5.14 0 1 1 5.14-5.08A5.12 5.12 0 0 1 12 17.13zm5.34-9.26a1.22 1.22 0 0 1-1.21-1.21 1.21 1.21 0 0 1 1.21-1.2 1.17 1.17 0 0 1 1.19 1.21 1.2 1.2 0 0 1-1.19 1.2zm-5.34.8A3.33 3.33 0 1 0 15.33 12 3.34 3.34 0 0 0 12 8.67z'/>
      </svg>
    </React.Fragment>
  );
}

InstagramIcon.propTypes = {
  altText: PropTypes.string.isRequired
};

export default InstagramIcon;
